/* tslint:disable */
import {
  Vendor
} from '../index';

declare var Object: any;
export interface SalesCampaignInterface {
  "name": string;
  "discountPercent": number;
  "status"?: number;
  "products"?: Array<any>;
  "startDate"?: any;
  "endDate"?: any;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  "updatedBy"?: any;
  "id"?: any;
  "vendorId"?: any;
  vendor?: Vendor;
}

export class SalesCampaign implements SalesCampaignInterface {
  "name": string;
  "discountPercent": number;
  "status": number;
  "products": Array<any>;
  "startDate": any;
  "endDate": any;
  "createdAt": Date;
  "updatedAt": Date;
  "updatedBy": any;
  "id": any;
  "vendorId": any;
  vendor: Vendor;
  constructor(data?: SalesCampaignInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SalesCampaign`.
   */
  public static getModelName() {
    return "SalesCampaign";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SalesCampaign for dynamic purposes.
  **/
  public static factory(data: SalesCampaignInterface): SalesCampaign{
    return new SalesCampaign(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SalesCampaign',
      plural: 'salesCampaigns',
      path: 'salesCampaigns',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "discountPercent": {
          name: 'discountPercent',
          type: 'number',
          default: 0
        },
        "status": {
          name: 'status',
          type: 'number',
          default: 0
        },
        "products": {
          name: 'products',
          type: 'Array&lt;any&gt;'
        },
        "startDate": {
          name: 'startDate',
          type: 'any'
        },
        "endDate": {
          name: 'endDate',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "vendorId": {
          name: 'vendorId',
          type: 'any'
        },
      },
      relations: {
        vendor: {
          name: 'vendor',
          type: 'Vendor',
          model: 'Vendor',
          relationType: 'belongsTo',
                  keyFrom: 'vendorId',
          keyTo: 'id'
        },
      }
    }
  }
}
